module.exports = __webpack_public_path__ + "static/mobile_logo-2cf71ac4c249498a1ce5be13433fc9a4.png";